import { useSelector } from 'react-redux';
import { selectPanelTypes } from '../../../redux/panelConfigSlice';
import { canAddChildPanel, getChildPanelTypes } from '../../../config/panelConfig/panelHierarchy';
import { PANEL_LEVEL } from '../../../config/panelConfig/panelTypes';

/**
 * usePanelHierarchy - Panel hiyerarşi doğrulama hook'u
 */
export function usePanelHierarchy() {
  const panelTypes = useSelector(selectPanelTypes);

  const canAddChild = (parentTypeId, childTypeId) => {
    return canAddChildPanel(parentTypeId, childTypeId, panelTypes);
  };

  const getChildTypes = (panelTypeId) => {
    return getChildPanelTypes(panelTypeId, panelTypes);
  };

  const validateHierarchy = (parentTypeId, childTypeId) => {
    const parent = panelTypes[parentTypeId];
    const child = panelTypes[childTypeId];
    if (!parent || !child) return { valid: false, reason: 'Panel tipi bulunamadı' };
    if (!parent.allowedChildPanels.includes(childTypeId)) {
      return { valid: false, reason: `${parent.label} altına ${child.label} eklenemez` };
    }
    return { valid: true, reason: null };
  };

  const getHierarchyTree = () => {
    const primaryTypes = Object.values(panelTypes).filter(
      pt => pt.level === PANEL_LEVEL.PRIMARY
    );
    return primaryTypes.map(pt => ({
      ...pt,
      children: pt.allowedChildPanels
        .map(childId => panelTypes[childId])
        .filter(Boolean),
    }));
  };

  return {
    canAddChild,
    getChildTypes,
    validateHierarchy,
    getHierarchyTree,
  };
}
